import { defineMessages } from 'react-intl';

export default defineMessages({
  propertySale: {
    id: 'global_property_sale',
    defaultMessage: 'Home',
  },
  propertyRent: {
    id: 'global_property_rent',
    defaultMessage: 'Home',
  },
  parkingSale: {
    id: 'global_property_sale_parking',
    defaultMessage: 'Parking',
  },
  parkingRent: {
    id: 'global_property_rent_parking',
    defaultMessage: 'Parking',
  },
  officeSale: {
    id: 'global_property_sale_office',
    defaultMessage: 'Office',
  },
  officeRent: {
    id: 'global_property_rent_office',
    defaultMessage: 'Office',
  },
  propertyLand: {
    id: 'global_property_land',
    defaultMessage: 'Land',
  },
  retailSale: {
    id: 'global_property_retail_sale',
    defaultMessage: 'Retail property',
  },
  retailRent: {
    id: 'global_property_retail_rent',
    defaultMessage: 'Retail property',
  },
  warehouseSale: {
    id: 'global_property_warehouse_sale',
    defaultMessage: 'Industrial unit',
  },
  warehouseRent: {
    id: 'global_property_warehouse_rent',
    defaultMessage: 'Industrial unit',
  },
  overseas: {
    id: 'global_property_overseas',
    defaultMessage: 'Overseas',
  },
  foreclosure: {
    id: 'global_property_unlisted_foreclosure',
    defaultMessage: 'Foreclosures',
  },
  retailTransfer: {
    id: 'global_property_retail_transfer',
    defaultMessage: 'Lease transfer',
  },
  temporallyRent: {
    id: 'global_temporally_rent',
    defaultMessage: 'Temporally rent',
  },
  flatShare: {
    id: 'global_property_flatshare',
    defaultMessage: 'Flatshare',
  },
});



// WEBPACK FOOTER //
// ./app/common/messages/homes.js